import { CommonModule }    from '@angular/common';
import { NgModule }        from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ImageViewerComponent } from './image-viewer.component';
import { ImageViewerService }   from './image-viewer.service';
import { ImageZoomDirective }   from './image-zoom.directive';

@NgModule({
  declarations: [
    ImageViewerComponent,
    ImageZoomDirective
  ],
  entryComponents: [
    ImageViewerComponent
  ],
  exports: [
    ImageViewerComponent,
    ImageZoomDirective
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  providers: [
    ImageViewerService
  ]
})
export class ImageViewModule {}
